/* eslint-env browser */
/* eslint-disable func-names */
/**
 * Training Info Component
 * Converted from jQuery to native JavaScript while preserving original behavior
 */
import { Component, registerComponent } from 'js/component.js';

const componentName = 'training-info';

class TrainingInfo extends Component {

    /**
     * Initialize Component
     */
    init() {

        // Add sort-value attr to ul's (from sort-date attr in courseDate li)
        const courseDetails = document.querySelectorAll('.course-detail[data-course-date]');
        courseDetails.forEach(function(courseDetail) {
            const courseDateStr = courseDetail.dataset.courseDate;
            const sortVal = Date.parse(courseDateStr.substring(0, 16));
            courseDetail.parentElement.setAttribute('data-sort-value', sortVal);
        });

        // Order ul's by sort-value
        const courseList = document.querySelector('.upcoming-courses');
        const courses = Array.from(document.querySelectorAll('.course-instance[data-sort-value]'));

        // Sort courses by sort-value (same logic as jQuery version)
        courses.sort((a, b) => {
            const aValue = parseInt(a.dataset.sortValue);
            const bValue = parseInt(b.dataset.sortValue);
            return aValue - bValue;
        });

        // Prepend sorted courses to course list (same as jQuery prependTo)
        courses.forEach(course => {
            if (courseList && courseList.contains(course)) {
                courseList.removeChild(course);
            }
        });
        courses.forEach(course => {
            if (courseList) {
                courseList.insertBefore(course, courseList.firstChild);
            }
        });

        // Exclude past dates (hide past courses)
        const todaysDate = new Date();
        const allCourseInstances = document.querySelectorAll('.course-instance');

        allCourseInstances.forEach(function(courseInstance) {
            const sortValue = parseInt(courseInstance.dataset.sortValue);
            if (sortValue && sortValue < Date.parse(todaysDate)) {
                courseInstance.style.display = 'none';
            }
        });
    }
}

registerComponent(`.${componentName}`, TrainingInfo);
